import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "cmp--header_cart-modal_cart-items-wrapper"
};
const _hoisted_2 = {
  key: 0,
  class: "cmp--header_cart-modal_purchase-cart"
};
const _hoisted_3 = {
  class: "cmp--header_cart-modal_cart-details"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "cmp--header_cart-modal_cart-icon",
  width: "15",
  height: "14",
  viewBox: "0 0 15 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M0.000610352 1.15263H2.02689L3.57831 8.90435L3.57841 8.90484C3.65695 9.30101 3.87259 9.65685 4.18744 9.90984C4.50088 10.1617 4.8927 10.2956 5.29461 10.2883H11.204C11.6053 10.2947 11.9963 10.1605 12.3089 9.90875C12.623 9.65593 12.8381 9.3007 12.9166 8.90526L12.9166 8.90526L12.9173 8.90145L13.8908 3.79119L14.0039 3.19763H13.3996H3.45601L2.92701 0.554502L2.84658 0.152626H2.43674H0.000610352V1.15263ZM4.55907 8.70913L3.65614 4.19763H12.7954L11.9357 8.71051L11.9354 8.71209C11.9024 8.87669 11.8126 9.02451 11.6818 9.12981C11.5506 9.23545 11.3864 9.29157 11.218 9.28835L11.218 9.28826H11.2084H5.28969V9.28814L5.27888 9.28837C5.11009 9.29202 4.94541 9.23605 4.8138 9.1303C4.68218 9.02455 4.59206 8.87579 4.55928 8.71017L4.55907 8.70913ZM6.09275 12.7424C6.09275 12.9609 6.02798 13.1745 5.90663 13.3561C5.78527 13.5378 5.61278 13.6794 5.41095 13.7631C5.20913 13.8468 4.98703 13.8687 4.77273 13.8262C4.55844 13.7836 4.36156 13.6785 4.207 13.5241C4.05243 13.3697 3.94711 13.1729 3.90435 12.9587C3.86159 12.7444 3.8833 12.5223 3.96676 12.3204C4.05021 12.1185 4.19165 11.9458 4.37319 11.8243C4.55474 11.7027 4.76825 11.6378 4.98672 11.6375C5.13191 11.6374 5.27571 11.6658 5.4099 11.7213C5.54408 11.7768 5.66602 11.8581 5.76874 11.9607C5.87146 12.0634 5.95294 12.1852 6.00854 12.3193C6.06414 12.4535 6.09275 12.5972 6.09275 12.7424ZM12.6764 12.7424C12.6764 12.9609 12.6116 13.1745 12.4902 13.3561C12.3689 13.5378 12.1964 13.6794 11.9946 13.7631C11.7927 13.8468 11.5706 13.8687 11.3563 13.8262C11.142 13.7836 10.9452 13.6785 10.7906 13.5241C10.636 13.3697 10.5307 13.1729 10.488 12.9587C10.4452 12.7444 10.4669 12.5223 10.5504 12.3204C10.6338 12.1185 10.7753 11.9458 10.9568 11.8243C11.1384 11.7027 11.3519 11.6378 11.5703 11.6375C11.7155 11.6374 11.8593 11.6658 11.9935 11.7213C12.1277 11.7768 12.2496 11.8581 12.3523 11.9607C12.4551 12.0634 12.5366 12.1852 12.5921 12.3193C12.6477 12.4535 12.6764 12.5972 12.6764 12.7424Z",
  fill: "white"
})], -1);
const _hoisted_5 = {
  class: "cmp--header_cart-modal_cart-name"
};
const _hoisted_6 = {
  class: "cmp--header_cart-modal_cart_buy"
};
const _hoisted_7 = ["href"];
const _hoisted_8 = {
  key: 1,
  class: "cmp--header_cart-modal_sample-cart"
};
const _hoisted_9 = {
  class: "cmp--header_cart-modal_cart-details"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19.548",
  height: "19.377",
  viewBox: "0 0 19.548 19.377",
  class: "cmp--header_cart-modal-tag feather-icon"
}, [/*#__PURE__*/_createElementVNode("g", {
  id: "Group_2879",
  "data-name": "Group 2879",
  transform: "translate(1 1)"
}, [/*#__PURE__*/_createElementVNode("path", {
  id: "Path_425",
  "data-name": "Path 425",
  d: "M19.854,13.344l-6.5,6.5a1.813,1.813,0,0,1-2.566,0L3,12.066V3h9.066l7.788,7.788A1.813,1.813,0,0,1,19.854,13.344Z",
  transform: "translate(-3 -3)",
  fill: "none",
  stroke: "#ffffff",
  "stroke-width": "1",
  class: "tabIcon"
}), /*#__PURE__*/_createElementVNode("path", {
  id: "Path_426",
  "data-name": "Path 426",
  d: "M10.5,10.5h0",
  transform: "translate(-5.967 -5.967)",
  fill: "none",
  stroke: "#ffffff",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "tabIcon"
})])], -1);
const _hoisted_11 = {
  class: "cmp--header_cart-modal_cart-name"
};
const _hoisted_12 = {
  class: "cmp--header_cart-modal_cart-quantity"
};
const _hoisted_13 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$options.hasPurchaseItems || $options.isBuyingUser && $options.hasSampleAdded ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString($options.purchaseCartText), 1), _createElementVNode("div", _hoisted_6, _toDisplayString($options.purchaseQuantity), 1)]), _createElementVNode("a", {
    href: $options.cartUrl
  }, [_createElementVNode("button", null, _toDisplayString($options.checkOutText), 1)], 8, _hoisted_7)])) : _createCommentVNode("", true), $options.hasSampleAdded ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString($options.sampleCartText), 1), _createElementVNode("div", _hoisted_12, _toDisplayString($options.sampleQuantity), 1)]), _createElementVNode("a", {
    href: $options.sampleCartLink
  }, [_createElementVNode("button", null, _toDisplayString($options.completeRequestText), 1)], 8, _hoisted_13)])) : _createCommentVNode("", true)]);
}